import { getFullScreenSize } from "@/utils/layout";
import ModalBaseContainer from '@max/leez-modal-base-container';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import LImage from '@max/leez-image';
import TopView from '@max/leez-top-view';
import LinearGradient from '@hfe/max-linear-gradient';
import ScrollView from '@hfe/max-scrollview';
import './index.scss';
import { useState, memo, useMemo, useCallback, createElement } from '@max/max';
// import { Animated } from '@max/mbc-animated';
// import AnimateView, { AnimatedViewProps } from '@max/mbc-animate-view';
import { toPx } from '@max/leez-style-util';
import VapView from "../vap-view";
import { FIREWORKS_VAP } from "@/const";
const offsetRow = [0, 164, 103];
function reorderArray(arr, startIndex) {
    // 切分数组
    const front = arr.slice(startIndex); // 从 startIndex 到末尾
    const back = arr.slice(0, startIndex); // 从开头到 startIndex 之前
    // 拼接
    return [...front, ...back];
}
// 将10个心愿分成3行
const getRowsData = (wishOptions) => {
    return [reorderArray(wishOptions, 0), reorderArray(wishOptions, Number((wishOptions.length / 3).toFixed(0))), reorderArray(wishOptions, Number((wishOptions.length / 3).toFixed(0)) * 2)];
};
// 横向滚动行组件
const ScrollingRow = memo((props) => {
    const { wishes, selectedId, onSelect, speed = 1, offsetLeft = 0, rowIndex, toRateSize } = props;
    const infiniteWishes = useMemo(() => [...wishes], [wishes]);
    return <View className="wish-row-container">
      <View className="wish-row-content" style={{
        marginLeft: `${offsetLeft !== null && offsetLeft !== void 0 ? offsetLeft : 0}rpx`
    }}>
        {infiniteWishes.map((wish, index) => {
        const isSelected = selectedId === wish.id;
        return <View key={`${wish.id}-${index}`} className="wish-option-card" onClick={() => onSelect(wish.id)}>
              <LImage source={{
            uri: isSelected ? wish.selectedImageUrl : wish.imageUrl
        }} className="wish-option-image" height={toPx(73)} resizeMode="cover"/>
            </View>;
    })}
      </View>
    </View>;
});
ScrollingRow.displayName = 'ScrollingRow';
export default function WishSelectionPopup(props) {
    const { fullScreenHeight, fullScreenWidth, width } = getFullScreenSize();
    const [selectedId, setSelectedId] = useState(props.selectedWishId);
    // 缓存 toRateSize 函数以避免 ScrollingRow 不必要的重新挂载
    // 使用 width 作为依赖而不是函数引用，width 是稳定的数值
    const toRateSize = useCallback((num) => {
        return num * width / 750;
    }, [width]);
    const { visible, onClose, onConfirm, wishOptions = [], titleImageUrl = 'https://p0.meituan.net/ingee/f73cac8077d251d8b0ec907516e1eae252287.png', confirmButtonText = '确认选择' } = props;
    const handleWishSelect = useCallback((wishId) => {
        setSelectedId(wishId);
    }, []);
    const handleConfirm = useCallback(() => {
        if (selectedId !== undefined) {
            onConfirm(selectedId);
        }
    }, [selectedId, onConfirm]);
    // 使用 useMemo 缓存行数据
    const rowsData = useMemo(() => getRowsData(wishOptions), [wishOptions]);
    //   if (!visible) {
    //     return null;
    //   }
    return <TopView>
      <ModalBaseContainer visible={visible} contentStyle={{
        width: '750rpx',
        height: fullScreenHeight,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative'
    }}>
        
        <View className="wish-selection-popup-container">
          <VapView {...FIREWORKS_VAP} isFullScreen widthHeightRatio={750 / 1642} height={fullScreenHeight} width={fullScreenWidth} style={{
        left: 0,
        position: 'absolute',
        top: '-440rpx'
        // top: -width * 2 / 3,
    }} keepLastFrame loop={false}/>
          
          <View className="wish-selection-popup-header">
            <LImage source={{
        uri: titleImageUrl
    }} style={{
        width: '626rpx',
        height: '131rpx'
    }} resizeMode="contain"/>
          </View>

          
          <ScrollView className="wish-selection-popup-scroll-container" horizontal={true} showsHorizontalScrollIndicator={false}>
            <View style={{
        display: 'flex',
        flexDirection: 'column'
    }}>
              {rowsData.map((rowWishes, rowIndex) => <ScrollingRow key={rowIndex} wishes={rowWishes} selectedId={selectedId} onSelect={handleWishSelect} offsetLeft={offsetRow[rowIndex]} // 每行不同的起始偏移（rpx）
     
    // offsetLeft={0}  // 每行不同的起始偏移（rpx）
    speed={1 + rowIndex * 0.3} // 每行不同的滚动速度
     rowIndex={rowIndex} toRateSize={toRateSize}/>)}
            </View>
          </ScrollView>

          
          <View className="wish-selection-popup-footer">
            <View onClick={handleConfirm}>
              <LinearGradient start={{
        x: 0,
        y: 0
    }} end={{
        x: 1,
        y: 0
    }} colors={['#FFE74D', '#FFDD00']} className='wish-confirm-button'>
                <Text className="wish-confirm-button-text">{confirmButtonText}</Text>
              </LinearGradient>
            </View>
          </View>
        </View>

        
        <LImage onPress={onClose} source={{
        uri: 'https://p0.meituan.net/ingee/94047ffc6fa8ede65644e7a2653da1691779.png'
    }} style={{
        width: '48rpx',
        height: '48rpx',
        marginTop: '60rpx'
    }} className="wish-selection-popup-close-btn"/>
      </ModalBaseContainer>
    </TopView>;
}
// 无限自动滚动代码，如有需要，可以切换
// 横向滚动行组件
// const ScrollingRow = memo((props: {
//   wishes: WishOption[];
//   selectedId?: string | number;
//   onSelect: (id: string | number) => void;
//   offsetLeft?: number;
//   speed?: number;
//   rowIndex: number;
//   toRateSize: (num: number) => number;
// }) => {
//   const { wishes, selectedId, onSelect, speed = 1, offsetLeft = 0, rowIndex, toRateSize } = props;
//   // 使用 Animated.Value 替代 useState
//   const scrollAnim = useRef(new Animated.Value(0));
//   const animationRef = useRef<any>(null);
//   const isAnimationStarted = useRef(false); // 标志位：动画是否已启动
//   // 创建3份数据实现无限滚动
//   const infiniteWishes = useMemo(() => [...wishes], [wishes]);
//   useEffect(() => {
//     // 如果动画已经启动，不要重新启动
//     if (isAnimationStarted.current) {
//       return;
//     }
//     const itemWidthRpx = 340; // 卡片宽度(320rpx) + 间距(20rpx)
//     const itemWidthPx = toRateSize(itemWidthRpx); // 转换为实际像素
//     const offsetLeftPx = toRateSize(offsetLeft); // 转换为实际像素
//     const singleSetWidthPx = wishes.length * itemWidthPx;
//     // 设置初始位置：从offsetLeft开始（显示第一组数据）
//     scrollAnim.current.setValue(-offsetLeftPx);
//     // 创建循环动画：从第一组数据的起始位置滚动到第一组数据的末尾
//     // 然后瞬间重置到起始位置（因为第二组数据和第一组内容相同）
//     const animation = Animated.loop(
//       Animated.sequence([
//         Animated.timing(scrollAnim.current, {
//           toValue: -(singleSetWidthPx + offsetLeftPx), // 滚动到第一组数据的末尾（实际像素）
//           duration: (singleSetWidthPx / speed) * 30, // 根据速度计算持续时间
//           useNativeDriver: true,
//           easing: Animated.Easing.linear,
//         }),
//         // 瞬间重置到起始位置（此时显示第二组数据的开头，视觉上和第一组开头相同）
//         Animated.timing(scrollAnim.current, {
//           toValue: -offsetLeftPx, // 重置到起始位置（实际像素）
//           duration: 0,
//           useNativeDriver: true,
//         }),
//       ]),
//       { iterations: Infinity }
//     );
//     animationRef.current = animation;
//     animation.start();
//     isAnimationStarted.current = true; // 标记动画已启动
//     // 清理动画
//     return () => {
//       if (animationRef.current) {
//         animationRef.current.stop();
//         isAnimationStarted.current = false;
//       }
//     };
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [wishes.length, speed, offsetLeft, rowIndex]);
//   // 计算总宽度（rpx单位，用于样式）
//   const itemWidthRpx = 340; // 卡片宽度(320rpx) + 间距(20rpx)
//   const totalWidthRpx = infiniteWishes.length * itemWidthRpx;
//   return (
//     <View className="wish-row-container">
//       <AnimateView
//         viewId={`wish-row-content-${rowIndex}`}
//         className="wish-row-content"
//         style={{
//           width: `${totalWidthRpx}rpx`,
//           transform: [{ translateX: scrollAnim.current as any }],
//         }}
//       >
//         {infiniteWishes.map((wish, index) => {
//           const isSelected = selectedId === wish.id;
//           return (
//             <View
//               key={`${wish.id}-${index}`}
//               className={`wish-option-card ${isSelected ? 'wish-option-card-selected' : ''}`}
//               onClick={() => onSelect(wish.id)}
//             >
//               <LImage
//                 source={{ uri: wish.imageUrl }}
//                 className="wish-option-image"
//                 style={{
//                   height: '78rpx',
//                 }}
//                 resizeMode="cover"
//               />
//               {isSelected && (
//                 <View className="wish-option-card-selected-border" />
//               )}
//             </View>
//           );
//         })}
//       </AnimateView>
//     </View>
//   );
// });
